import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { selectChatCofig, selectIsChatOpen } from "../../../../entities/settings/model";
import { selectIsSocketReady } from "../../../../entities/socket/model";
import { ymPushSendMessage } from "../../../../shared/analytics";
import { FSMStages, useAppSelector, useFSM } from "../../../../shared/model";
import { createSendMessageEvent } from "../../../../shared/lib";
export var useInitialSubmit = function useInitialSubmit() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    queuedMessage = _useState2[0],
    setQueuedMessage = _useState2[1];
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var isSendedRef = useRef(false);
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var isSocketReady = useAppSelector(selectIsSocketReady);
  var isOpen = useAppSelector(selectIsChatOpen);
  useEffect(function () {
    if (queuedMessage && isOpen && (zoneType === 'unauthorized' ? stage === FSMStages.CAPTCHA_NEEDED : isSocketReady) && !isSendedRef.current) {
      createSendMessageEvent(queuedMessage);
      isSendedRef.current = true;
      ymPushSendMessage();
    }
  }, [isSocketReady, isOpen, queuedMessage, stage]);
  return setQueuedMessage;
};